import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { useLanguage } from "@/context/LanguageContext";
import { getServices } from "@/lib/siteContent";

const Footer = () => {
  const year = new Date().getFullYear();
  const { language, t } = useLanguage();
  const services = getServices(language).slice(0, 5);

  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Logo size={40} />
          <p className="mt-5 text-sm text-slate-600 leading-relaxed max-w-sm">
            {t("footer.blurb")}
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-4">
            {t("footer.services")}
          </h4>
          <ul className="space-y-2.5 text-sm text-slate-700">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/hizmetler/${s.slug}`} className="hover:text-teal-700">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-4">
            {t("footer.corporate")}
          </h4>
          <ul className="space-y-2.5 text-sm text-slate-700">
            <li><Link to="/hakkimizda" className="hover:text-teal-700">{t("nav.about")}</Link></li>
            <li><Link to="/blog" className="hover:text-teal-700">{t("nav.blog")}</Link></li>
            <li><Link to="/iletisim" className="hover:text-teal-700">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-4">
            {t("footer.contact")}
          </h4>
          <ul className="space-y-3 text-sm text-slate-700">
            <li className="flex items-start gap-2.5">
              <Mail size={15} className="mt-0.5 text-teal-700" />
              <a href="mailto:info@maddekayit.com" className="hover:text-teal-700">
                info@maddekayit.com
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <Phone size={15} className="mt-0.5 text-teal-700" />
              <a href="tel:+902128120295" className="hover:text-teal-700">0212 812 02 95</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="mt-0.5 text-teal-700" />
              <span>{t("footer.location")}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-2">
          <div>© {year} Madde Kayıt — {t("footer.rights")}</div>
          <div className="font-display italic">
            {t("footer.strapline")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
